import { chakra, HTMLChakraProps } from '@chakra-ui/react'

interface ContextSwitchArrowsProps extends HTMLChakraProps<'svg'> {
  size?: number
  color?: string
  className?: string
}

export const ContextSwitchArrows = ({
  size = 32,
  color = 'currentColor',
  className,
  ...props
}: ContextSwitchArrowsProps) => {
  return (
    <chakra.svg
      viewBox="0 0 20 20"
      width={size}
      height={size}
      fill={color}
      className={className}
      aria-hidden="true"
      {...props}
    >
      <g fillRule="evenodd" transform="translate(-446 -398)">
        <g fillRule="nonzero">
          <path
            d="M96.628 206.613A7.97 7.97 0 0 1 96 203.5a7.967 7.967 0 0 1 2.343-5.657A7.978 7.978 0 0 1 104 195.5a7.978 7.978 0 0 1 5.129 1.86.75.75 0 0 0 .962-1.15A9.479 9.479 0 0 0 104 194a9.478 9.478 0 0 0-6.717 2.783A9.467 9.467 0 0 0 94.5 203.5a9.47 9.47 0 0 0 .747 3.698.75.75 0 1 0 1.381-.585zm14.744-6.226A7.97 7.97 0 0 1 112 203.5a7.967 7.967 0 0 1-2.343 5.657A7.978 7.978 0 0 1 104 211.5a7.978 7.978 0 0 1-5.128-1.86.75.75 0 0 0-.962 1.152A9.479 9.479 0 0 0 104 213a9.478 9.478 0 0 0 6.717-2.783 9.467 9.467 0 0 0 2.783-6.717 9.47 9.47 0 0 0-.747-3.698.75.75 0 1 0-1.381.585z"
            transform="translate(352 204.5)"
          />
          <path
            d="M109.5 197h-2.25a.75.75 0 1 0 0 1.5h3a.75.75 0 0 0 .75-.75v-3a.75.75 0 1 0-1.5 0V197zm-11 13h2.25a.75.75 0 1 0 0-1.5h-3a.75.75 0 0 0-.75.75v3a.75.75 0 1 0 1.5 0V210z"
            transform="translate(352 204.5)"
          />
        </g>
      </g>
    </chakra.svg>
  )
}
